import React, {useEffect, useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Editor from "../../common/Editor";
import {MODE_CREATE, MODE_EDIT} from "../../codes";
import {useMutation} from "@tanstack/react-query";
import useToast from "../../util/useToast";
import {apiCreateVehicule, apiUpdateVehicule} from "../../api/ApiVehicules";
import {VehiculeErrors} from "../../errors/ErrorsMapping";
import { TextEditor } from "../../lexical/TextEditor";

const VehiculeEditor = ({show, mode, hide, onSubmit, vehicule = {}}) => {
  const {showToastSuccess} = useToast();

  const [formData, setFormData] = useState({
    name: "",
    description: ""
  });

  const [formErrors, setFormErrors] = useState({});

  const nameRef = useRef(null);
  const editorRef = useRef(null);

  const createMutation = useMutation(apiCreateVehicule());
  const editMutation = useMutation(apiUpdateVehicule(vehicule.id));

  useEffect(() => {
    if (show) {
      setFormErrors({});

      setFormData({
        name: vehicule.name || "",
        description: vehicule.description || "",
      });

      nameRef.current.focus();
    }
  }, [show, vehicule]);

  const updateFormData = field => e => {
    const values = {};

    switch (field) {
      default:
        values[field] = e.target.value;
        break;
    }

    setFormData(prev => ({...prev, ...values}));
  };

  const submit = () => {
    let promise;

    const submitData = {
      ...formData,
      description: editorRef.current?.getHtml() || ""
    };

    if (mode === MODE_EDIT) {
      promise = editMutation.mutateAsync(submitData);
    } else {
      promise = createMutation.mutateAsync(submitData);
    }

    return promise
      .then(() => {
        return (onSubmit ? onSubmit() : Promise.resolve()).then(() => {
          if (mode === MODE_EDIT) {
            showToastSuccess("Véhicule modifié");
          } else {
            showToastSuccess("Véhicule ajouté");
          }
        });
      })
      .then(hide)
      .catch((err) => {
        if (err.response?.status === 400) {
          setFormErrors(err.response.data.errors);
        }
      });
  };

  return <Editor
    show={show}
    title={mode === MODE_CREATE ? "Ajouter un véhicule" : "Modifier un véhicule"}
    onSubmit={submit}
    onCancel={hide}
    submitLabel="Sauvegarder"
    cancelLabel="Annuler"
  >
    <Form.Group className="mb-2" controlId="vehicule-editor-name">
      <Row>
        <Form.Label column sm={3}>Nom</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="text"
            value={formData.name}
            onChange={updateFormData("name")}
            maxLength="255"
            ref={nameRef}
            isInvalid={!!formErrors.name}
          />

          <Form.Control.Feedback type="invalid">{VehiculeErrors.name[formErrors.name]}</Form.Control.Feedback>
        </Col>
      </Row>
    </Form.Group>

    <Form.Group className="mb-2" controlId="vehicule-editor-description">
      <Row>
        <Form.Label column sm={3}>Description</Form.Label>
        <Col sm={9}>
          <TextEditor ref={editorRef} value={formData.description} />
        </Col>
      </Row>
    </Form.Group>
  </Editor>;
};

export default VehiculeEditor;
